import Reducer from './../util/reducer'

const reducer = new Reducer()

reducer.register('LOAD_FACEBOOK', (info) => {
  return {
    loadedState: info.state
  }
})

reducer.register('GET_FACEBOOK_LOGIN_STATUS', (info) => {
  return {
    authState: info.state,
    authToken: info.token
  }
})

export default reducer.build()
